import { createStore, produce } from "solid-js/store";

const BREAKPOINT = 932;
const THROTTLE_DELAY = 200; // 200ms 的节流时间

export interface SidebarContainerState {
  isExpanded: boolean;
}

const [state, setState] = createStore<SidebarContainerState>({
  isExpanded: false,
});

// 节流函数
const throttle = <T extends (...args: unknown[]) => void>(
  fn: T,
  delay: number,
) => {
  let lastCall = 0;
  return function (...args: Parameters<T>) {
    const now = Date.now();
    if (now - lastCall >= delay) {
      lastCall = now;
      return fn(...args);
    }
  };
};

// 切换侧边栏展开/收起状态
const toggleSidebar = () => {
  setState(
    produce((s) => {
      s.isExpanded = !s.isExpanded;
    }),
  );
};

// 监听窗口大小变化
const handleResize = throttle(() => {
  // TODO:缩小跳转到h5 notify界面，放大打开sidebar
  const shouldBeExpanded = window.innerWidth > BREAKPOINT;
  setState(
    produce((s) => {
      if (s.isExpanded) {
        s.isExpanded = shouldBeExpanded;
      }
    }),
  );
}, THROTTLE_DELAY);

// 初始化
const initSidebar = () => {
  // 添加 resize 事件监听
  window.addEventListener("resize", handleResize);

  // 返回清理函数
  return () => {
    window.removeEventListener("resize", handleResize);
  };
};

// 导出
export const sidebarContainerStore = {
  state,
  toggleSidebar,
  initSidebar,
};
